// extracted by mini-css-extract-plugin
module.exports = {"field":"BasicView_field__2G3fk","fieldRowWise":"BasicView_fieldRowWise__paD0k","title":"BasicView_title__HpG25","value":"BasicView_value__2doAb","dot":"BasicView_dot__efH7H"};